module.exports = __webpack_public_path__ + "media/images/countryrect/ng-f684c48b91994ea1eef278cdb2f2db06.svg";